import EventSignpostingIconsTypes from './types/index.js';
import Image from 'presentation/components/image/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';

export default function EventSignpostingIcons(props) {
    const {
        mojitoTools: { config, style },
    } = props;
    const { BET_BUILDER, PRICE_BOOST, STREAMING, NEUTRAL_VENUE } = EventSignpostingIconsTypes.ICONS;
    const { hasBetBuilderMarket, hasBoostedMarkets, hasStreaming, isNeutralVenue } = props;

    const result = config.icons
        .map(icon => {
            switch (icon) {
                case BET_BUILDER:
                    return (
                        hasBetBuilderMarket && (
                            <Image
                                key={icon}
                                class="ta-BetBuilderIcon"
                                config={style.betBuilderIcon}
                            />
                        )
                    );
                case PRICE_BOOST:
                    return (
                        hasBoostedMarkets && (
                            <Image
                                key={icon}
                                class="ta-PriceBoostIcon"
                                config={style.priceBoostIcon}
                            />
                        )
                    );
                case STREAMING:
                    return (
                        hasStreaming && (
                            <Image
                                key={icon}
                                config={style.streamingIcon}
                                class="ta-StreamingIndicator"
                            />
                        )
                    );
                case NEUTRAL_VENUE:
                    return (
                        isNeutralVenue && (
                            <Image
                                key={icon}
                                class="ta-NeutralVenue"
                                config={style.neutralVenueIcon}
                            />
                        )
                    );
                default:
                    return null;
            }
        })
        .filter(Boolean);

    return result.length > 0 && <FlexPane config={config.iconsContainer}>{result}</FlexPane>;
}

EventSignpostingIcons.getStyle = (config, mode, merge) => {
    return {
        streamingIcon: merge(config.baseSignpostIcon, config.streamingIcon),
        betBuilderIcon: merge(config.baseSignpostIcon, config.betBuilderIcon),
        priceBoostIcon: merge(config.baseSignpostIcon, config.priceBoostIcon),
        neutralVenueIcon: merge(config.baseSignpostIcon, config.neutralVenueIcon),
    };
};
